exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-page{position:relative;width:100%;display:grid;grid-template-columns:var(--outer-gutter-col) repeat(12,1fr) var(--outer-gutter-col);grid-gap:0 var(--gutter);background-color:var(--body-bg-color)}#home-page .heading{grid-column:8/12;grid-row:1;padding-top:var(--body-layout-top-gap)}#home-page .content{grid-column:8/12;grid-row:2}#home-page .sub-menu{grid-column:6/8;grid-row:2}", ""]);

// exports
